import React, { useEffect, useState } from "react";
import { Backdrop, CircularProgress, Typography } from "@mui/material";
import { toast } from "react-toastify";
import FormAccordion from "../../components/Form/FormAccordion";
import { PasswordField } from "../../components/Form/FormComponents";
import { Formgroup, ButtonGroup, Button } from "../Products/Forms/ProductForm.styled";
import { getCurrentUserInfo } from "../../utils/UserAuth";
import Parse from "../../api/ApiConfig";

const AdminPin = () => {
	const accessPin = getCurrentUserInfo().accessPin || "0000";

	const [loading, setLoading] = useState(false);
	const [invalidPinError, setInvalidPinError] = useState(false);
	const [invalidConfirmPinError, setInvalidConfirmPinError] = useState(false);
	const [formData, setFormData] = useState({
		oldPin: "",
		newPin: "",
		confirmPin: "",
	});

	const { oldPin, newPin, confirmPin } = formData;

	const handleInputChange = (e) => {
		if (isNaN(e.target.value)) {
			return;
		}
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmitPin = async (e) => {
		e.preventDefault();

		if (oldPin !== accessPin) {
			toast.error("Old pin is incorrect");
			return;
		}
		if (confirmPin !== newPin) {
			toast.error("New pin does not match");
			return;
		}

		try {
			setLoading(true);
			const query = new Parse.Query("User");
			const object = await query.get(Parse.User.current()?.id);

			await object.save({ accessPin: confirmPin });

			toast.success("Your transaction pin has been updated successfully.");
			setFormData({
				oldPin: "",
				newPin: "",
				confirmPin: "",
			});
		} catch (error) {
			console.log(error);
			if (error?.message === "Network Error") {
				toast.error("Oops, Service provider has been disconnected!");
			} else {
				toast.error("Failed to create new access pin.");
			}
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (oldPin.length < 4) {
			return;
		} else if (oldPin !== accessPin) {
			setInvalidPinError(true);
			setTimeout(() => {
				setInvalidPinError(false);
			}, 1500);
		}
	}, [oldPin]);

	useEffect(() => {
		if (confirmPin.length < 4) {
			return;
		} else if (confirmPin !== newPin) {
			setInvalidConfirmPinError(true);
			setTimeout(() => {
				setInvalidConfirmPinError(false);
			}, 1500);
		}
	}, [confirmPin]);

	return (
		<>
			{loading && (
				<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
			<FormAccordion className='mt-4' title='Trasaction Pin Creation / Update' open={true}>
				<form onSubmit={handleSubmitPin}>
					<div className='grid grid-cols-3 gap-5 mt-5'>
						<Formgroup type='users'>
							<label htmlFor='oldPin'>Old Pin</label>
							<PasswordField
								name='oldPin'
								value={oldPin}
								handleChange={handleInputChange}
								required={true}
								context='pin'
							/>
							{accessPin === "0000" && (
								<Typography variant='p' component='h2' fontWeight='500'>
									NB: Use 0000 as old pin
								</Typography>
							)}
							{invalidPinError && (
								<Typography variant='body2' component='p' color='red' marginTop={-1}>
									Old Pin is incorrect
								</Typography>
							)}
						</Formgroup>
						<Formgroup type='users'>
							<label htmlFor='newPin'>New Pin</label>
							<PasswordField
								name='newPin'
								value={newPin}
								handleChange={handleInputChange}
								required={true}
								context='pin'
							/>
						</Formgroup>
						<Formgroup type='users'>
							<label htmlFor='confirmPin'>Confirm Pin</label>
							<PasswordField
								name='confirmPin'
								value={confirmPin}
								handleChange={handleInputChange}
								required={true}
								context='pin'
							/>
							{invalidConfirmPinError && (
								<Typography variant='body2' component='p' color='red' marginTop={-1}>
									Pin does not match
								</Typography>
							)}
						</Formgroup>
					</div>
					<ButtonGroup>
						<Button type='submit' color='#ffffff' backgroundcolor='#003A50'>
							<p>Save Changes</p>
						</Button>
					</ButtonGroup>
				</form>
			</FormAccordion>
		</>
	);
};

export default AdminPin;
